<template>
    <div tabindex="0" class="menu menu-sm dropdown-content left-1/2 translate-x-[-50%] min-w-72 mt-3 p-6 shadow border border-border bg-base-200 rounded-lg z-50">
        <span class="text-lg text-center text-headline font-semibold pb-4">{{ t('customer.account.headline') }}</span>
        <ul>
            <li class="border-b border-border h-12 mb-0.5">
                <MiscLink no-prefetch to="/customer" class="flex items-center text-primary-content gap-1 text-lg py-2 px-2 font-semibold justify-between w-full">
                    {{ t('customer.navigation.overview') }}
                    <MiscIcon name="chevron-right" class="w-6 h-6" />
                </MiscLink>
            </li>
            <li class="border-b border-border h-12 my-0.5">
                <MiscLink no-prefetch to="/customer/account" class="flex items-center text-primary-content gap-1 text-lg py-2 px-2 font-semibold justify-between w-full mt-0.5">
                    {{ t('customer.navigation.account') }}
                    <MiscIcon name="chevron-right" class="w-6 h-6" />
                </MiscLink>
            </li>
            <li class="border-b border-border h-12 my-0.5">
                <MiscLink no-prefetch to="/customer#editNewsletter" class="w-[274px] flex items-center text-primary-content gap-1 text-lg py-2 px-2 font-semibold justify-between mt-0.5">
                    <span>{{ t('customer.navigation.newsletterAbo') }}</span>
                    <MiscIcon name="chevron-right" class="w-6 h-6" />
                </MiscLink>
            </li>
            <li>
                <button type="button" class="flex items-center text-primary-content gap-1 text-lg mt-6 py-2 px-2 font-semibold justify-between w-full" @click="logout()">
                    <span>{{ t('customer.navigation.logout') }}</span>
                    <MiscIcon name="sign-out" class="w-6 h-6 mr-2 fill-link" />
                </button>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { useCustomer } from '#imports'
import { useI18n } from 'vue-i18n'

defineProps({
    horizontal: Boolean
})

const { t } = useI18n()
const { logout } = useCustomer()
</script>
